export default __webpack_public_path__ + "static/media/photo_5282747746622312914_y.697831aa.jpg";